import { Button } from "@/components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import type { FlowGroups } from "./items"
import { flowTitle } from "./text"

interface Props {
  outcome?: PlaybookOutcome
  groups: FlowGroups
  onChange: (outcome: PlaybookOutcome) => void
}

export function OutcomeMenu({ outcome, groups, onChange }: Props) {
  const label = outcome?.type === "goto"
    ? `Goto ${flowTitle(groups, outcome.flow)} > ${groups[outcome.flow]?.items.find(i => i.id === outcome.item)?.title || outcome.item}`
    : outcome?.type === "reset" ? "Reset" : "Next"

  return <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant="outline" size="sm">{label}</Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuItem onClick={() => onChange({ type: "next" })}>Next</DropdownMenuItem>
      <DropdownMenuItem onClick={() => onChange({ type: "reset" })}>Reset</DropdownMenuItem>
      <DropdownMenuSub>
        <DropdownMenuSubTrigger>Goto</DropdownMenuSubTrigger>
        <DropdownMenuSubContent>
          {Object.keys(groups).map(flow => <DropdownMenuSub key={flow}>
            <DropdownMenuSubTrigger>{flowTitle(groups, flow)}</DropdownMenuSubTrigger>
            <DropdownMenuSubContent>
              {groups[flow].items.map(item => <DropdownMenuItem key={item.id} onClick={() => onChange({ type: "goto", flow, item: item.id })}>{item.title || item.id}</DropdownMenuItem>)}
            </DropdownMenuSubContent>
          </DropdownMenuSub>)}
        </DropdownMenuSubContent>
      </DropdownMenuSub>
    </DropdownMenuContent>
  </DropdownMenu>
}
